var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page"},[_c('div',[_c('p',[_vm._v("Not found")]),_c('p',[_vm._v("そのURLは存在しません")]),_c('p',[_vm._v(" Top Page→ "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.topPageUrl))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }